import React, { Component } from "react";
import bttn from "../../assets/icons/add.svg";

class AddClassBttn extends Component {
  render() {
    return (
      <div
        style={{
          padding: "0px",
          border: "0px",
          backgroundColor: "#232D43",
          border: '1px solid #2C698D',
          boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)",
          borderRadius: "5px",
          outline: "none",
          width: "375px",
          height: "52px",
          color: "#394D78",
          fontSize: "14px",
          fontFamily: "Helvetica",
          fontStyle: "normal",
          fontWeight: "300",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <img src={bttn} alt="add" style={{ paddingRight: "5px" }} />
        Add Sample
      </div>
    );
  }
}

export default AddClassBttn;
